import type { DistributionDataSet } from '../../../../DataProvider/types';
import type { DataConverter, SheetData } from '../types';
import { formatColumnName } from './utils';

/**
 * Convert DistributionDataSet to sheet format
 * Used for distribution/KDE charts
 */
export const convertDistributionDataToSheet: DataConverter<
  DistributionDataSet
> = ({ data, primaryDimension }): SheetData[] => {
  const formattedPrimaryDimension = formatColumnName(primaryDimension);

  return data.data.flatMap((distribution) =>
    distribution.distribution.map((point) => ({
      [formattedPrimaryDimension]: distribution.dim,
      Value: point.value,
      Density: point.kde,
      CDF: point.cdf,
    }))
  );
};
